module.exports = __webpack_public_path__ + "static/media/stepOne.a7dc22ac.png";